<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Cf_Mg_Group' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView
      [controlClose]="true"
      (onChange)="handleChange($event)"
      (onClose)="closeTab($event)"
      [activeIndex]="index"
      >
      <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
        <div class="table-tools">
          <button (click)="add($event)"
            class="p-button p-component p-button-text-only btn-square"
            >
            {{'Cf_Add_Group' | translate}}
          </button>
        </div>
        <p-table
          #dt
          [selectionMode]="'single'"
          [columns]="listColumns"
          [value]="dataList"
          [rows]="100"
          [paginator]="true"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="showDetails($event)"
          (onFilter)="setFilteredList($event)"
          [sortField]="'name'"
          >
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ dataList.length }} {{'Cf_Groups' | translate}}</span>
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th class="width-col-3">
                <i class="pi pi-copy" pTooltip="{{'Cf_Dup' | translate}}"></i>
              </th>
              <th class="width-col-3" pTooltip="{{'Cf_Wiz' | translate}}">
                {{'Cf_W' | translate}}
              </th>
              <th [pSortableColumn]="columns[1].field" class="width-auto">
                <p-sortIcon [field]="columns[1].field"></p-sortIcon>{{columns[1].header}}
                <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[1].field, 'contains')"
                  style="color: darkgrey;">
                </th>
                <th [pSortableColumn]="columns[2].field" class="width-auto">
                  <p-sortIcon [field]="columns[2].field"></p-sortIcon>{{columns[2].header}}
                  <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[2].field, 'contains')"
                    style="color: darkgrey;">
                </th>
                <th [pSortableColumn]="columns[3].field" class="width-auto">
                  <p-sortIcon [field]="columns[3].field"></p-sortIcon>{{columns[3].header}}
                  <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[3].field, 'contains')"
                    style="color: darkgrey;">
                </th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-columns="columns" pTemplate="body">
            <tr [pSelectableRow]="rowData">
              <td (click)="clickcolDup($event, rowData)">
                <i class="pi pi-copy"></i>
              </td>
              <td class="width-auto">
                <div class="align">
                  @if (rowData[columns[0].field] === 1) {
                    <i
                      class="pi pi-star"
                    ></i>
                  }
                </div>
              </td>
              <td class="width-auto">
                {{ rowData[columns[1].field] }}
              </td>
              <td class="width-auto">
                {{ rowData[columns[2].field] }}
              </td>
              <td class="width-auto">
                {{ rowData[columns[3].field] }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      @for (item of itemsSelected; track item; let i = $index) {
        <p-tabPanel
          header="{{ item._label }}"
          [selected]="i == index - 1"
          [closable]="true"
          >
          @if (item.id === -1) {
            <app-add-group
              [userListBase]="userListBase"
              (onCancel)="cancelAdd($event)"
              (onValidate)="addTab($event)"
              >
            </app-add-group>
          }
          @if (item.id !== -1) {
            <app-edit-group
              [item]="item"
              [duplicate]="duplicate"
              [userListBase]="userListBase"
              (onCancel)="closeTab($event)"
              (onValidate)="validateTab($event)"
              (onDeleteItem)="confirmDelete($event)"
              (onLoadItem)="onLoadItem($event)"
              >
            </app-edit-group>
          }
        </p-tabPanel>
      }
    </p-tabView>
  </div>
</div>
<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>